import { DropDown, DropDownProps, MultipleDropDownProps } from 'components'

import FormRow, { FormRowProps } from './FormRow'
import styles from './FormRow.module.scss'

type DropDownFormRowProps<T> = FormRowProps & (DropDownProps<T> | MultipleDropDownProps<T>)

const DropDownFormRow = <T,>({
  className,
  error,
  description,
  mandatory,
  mode,
  title,
  ...dropDownProps
}: DropDownFormRowProps<T>) => (
  <FormRow
    className={className}
    description={description}
    error={error}
    mandatory={mandatory}
    mode={mode}
    title={title}
  >
    <DropDown className={styles.dropDown} placeholder={title} {...dropDownProps} />
  </FormRow>
)

export default DropDownFormRow
